// extracted by mini-css-extract-plugin
export default {"form":"CardForm_form__CMKHP","inline":"CardForm_inline__ZlKyn"};